import { Link, useLocation } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import MobileFooter from './MobileFooter';

const Footer = () => {
  const location = useLocation();

  // 하단 GNB가 표시되는 페이지에서는 MobileFooter 숨김
  const bottomNavPages = ['/', '/courses', '/my'];
  const showMobileFooter = !(
    bottomNavPages.includes(location.pathname) ||
    location.pathname.startsWith('/stay')
  );

  return <>
      {showMobileFooter && <MobileFooter />}
      <footer className="hidden md:block bg-gray-50 border-t border-gray-200 mt-12">
      <div className="max-w-7xl mx-auto px-4 py-6">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-3 md:col-span-2">
            <div className="flex items-center space-x-2">
              <img src="/images/logo.svg" alt="홀씨" className="h-8 w-auto" />
              
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">
              액티브 시니어를 위한<br />
              프리미엄 트레킹 투어 서비스
            </p>
            <div className="flex items-center space-x-2 text-sm text-gray-600">
              <MapPin size={16} />
              <span>경기도 남양주시 다산동 6614-1, 다산 현대 프리미어 캠퍼스몰 A동 8층 39호</span>
            </div>
            <div className="flex items-center space-x-2 text-sm text-gray-600">
              <Phone size={16} />
              <span>010-3741-2556</span>
            </div>
            <div className="flex items-center space-x-2 text-sm text-gray-600">
              <Mail size={16} />
              <span> support@wholsee.kr</span>
            </div>
          </div>

          {/* Right Side - Customer Support & Service Terms */}
          <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Support */}
            <div className="space-y-3">
              <h3 className="font-semibold text-gray-900">고객지원</h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li>
                  <Link to="/faq" className="hover:text-[#F39800] transition-colors">
                    자주 묻는 질문
                  </Link>
                </li>
                <li>
                  
                </li>
                <li>
                  <Link to="/refund-policy" className="hover:text-[#F39800] transition-colors">
                    취소/환불안내
                  </Link>
                </li>
                <li>
                  
                </li>
              </ul>
              <div className="flex items-center space-x-2 text-sm text-gray-600 pt-2">
                <Clock size={16} />
                <span>평일 09:00 - 18:00</span>
              </div>
            </div>

            {/* Legal */}
            <div className="space-y-3">
              <h3 className="font-semibold text-gray-900">서비스 약관</h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li>
                  <a href="/terms" className="hover:text-[#F39800] transition-colors">
                    이용약관
                  </a>
                </li>
                <li>
                  <a href="/privacy" className="hover:text-[#F39800] transition-colors">
                    개인정보처리방침
                  </a>
                </li>
                <li>
                  <a href="/location-terms" className="hover:text-[#F39800] transition-colors">
                    위치정보이용약관
                  </a>
                </li>
                <li>
                  
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200 mt-6 pt-4">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* Copyright */}
            <div className="text-sm text-gray-500">© 2025 (주)닷옴. All rights reserved.</div>

            {/* Business Info */}
            <div className="text-sm text-gray-500 text-center md:text-right">
              <div>사업자등록번호: 874-88-02713</div>
              <div>통신판매업신고번호: 제2024-서울강남-0000호</div>
              <div>관광사업등록번호: 제0000-000호</div>
            </div>
          </div>
        </div>

      </div>
    </footer>
    </>;
};
export default Footer;